export default {
	ok: "Confirm",
	cancel: "Cancel",
	areYouSure: "Are you sure?",
	cantRevert: "You will not be able to revert this.",
};
